export const translations = {
  fr: {
    nav: {
      predict: 'Planifier',
      live: 'Maintenant',
      dashboard: 'Gare',
      transporters: 'Transporteurs',
      history: 'Historique',
      trends: 'Tendances',
      profile: 'Profil',
    },
    navDesc: {
      predict: 'Je pars quand ?',
      live: "C'est bondé là ?",
      dashboard: 'Chiffres réels de la gare',
      transporters: 'Catalogue opérateurs',
      history: 'Recherches récentes',
      trends: 'Patterns hebdo',
      profile: 'Paramètres',
    },
    sidebar: {
      collapse: 'Réduire',
      themeLight: 'Clair',
      themeDark: 'Sombre',
      themeSystem: 'Système',
    },
    search: {
      from: 'Gare de départ',
      fromValue: 'Alger (Kharouba)',
      to: 'Destination',
      chooseDest: 'Choisir la destination',
      loadingDest: 'Chargement des destinations...',
      today: "Aujourd'hui",
      tomorrow: 'Demain',
      choose: 'Choisir',
      dayNames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      dayFull: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      searchBtn: 'Voir la prévision',
      loading: 'Calcul en cours...',
      errorMsg: 'Erreur lors du calcul. Réessayez.',
    },
    liveToggle: {
      mine: 'Ma destination',
      all: 'Toute la gare',
    },
    via: 'via',
    board: {
      station: (id: number) => (id === 1 ? 'Alger · Caroubier' : id === 2 ? 'Alger · Kharouba' : 'Alger (Kharouba)'),
      title: (station: string) => `Gare d'${station} · tous les départs`,
      empty: "Aucun départ aujourd'hui pour cette gare.",
      pastGone: (n: number) => `${n} déjà ${n > 1 ? 'partis' : 'parti'}`,
      upcoming: (n: number) => `${n} départ${n > 1 ? 's' : ''} à venir`,
      open: 'ouvert',
      gone: 'parti',
      assured: 'assuré',
      full: 'complet',
      seats: 'pl.',
      min: 'min',
    },
    sync: {
      live: 'En direct',
      now: "à l'instant",
      agoSec: (s: number) => `il y a ${s}s`,
      agoMin: (m: number) => `il y a ${m} min`,
      auto: (s: number) => `auto ${s}s`,
      title: (s: number) => `Actualisation automatique toutes les ${s}s`,
    },
    slotVerdict: {
      complete: 'Complet',
      high: 'Plein',
      medium: 'Se remplit',
      low: 'Tranquille',
    },
    slots: {
      header: (day: string, n: number) => `${day} · ${n} départ${n > 1 ? 's' : ''}`,
      legendLow: 'tranquille',
      legendMedium: 'se remplit',
      legendHigh: 'plein',
      srcLive: 'Places restantes en direct',
      srcHist: (n: number, day: string) => `Moyenne sur ${n} ${day}${n > 1 ? 's' : ''} passé${n > 1 ? 's' : ''}`,
      srcHistEst: ' (estimation)',
      srcSynthetic: 'Estimation (peu de données)',
    },
    verdict: {
      noData: 'Pas assez de données',
      noDataSub: 'Réessaie plus tard ou choisis un autre jour.',
      noMore: "Plus de départs aujourd'hui",
      noMoreSub: 'Essaie une autre date.',
      goToday: (time: string) => `Créneau estimé le moins chargé : ${time}`,
      goFuture: (day: string, time: string) => `${day}, créneau estimé le moins chargé : ${time}`,
      goSub: (pct: number, isToday: boolean) =>
        `~${pct}% d'occupation estimée${isToday ? " d'ici la fin de journée" : ''}.`,
      waitHead: (time: string) => `Créneau estimé le plus calme : ${time}`,
      waitSub: (pct: number, isToday: boolean) =>
        `~${pct}% d'occupation estimée${isToday ? " d'ici la fin de journée" : ''}. Arrive un peu en avance.`,
      avoidHead: (isToday: boolean) => `Fréquentation estimée élevée${isToday ? " d'ici la fin de journée" : ''}`,
      avoidSub: (time: string, pct: number) =>
        `Le moins chargé estimé : ${time} (~${pct}%). Essaie un autre jour si possible.`,
    },
    badge: {
      low: 'faible',
      medium: 'modéré',
      high: 'élevé',
    },
    altDays: {
      title: 'Jours alternatifs moins chargés',
    },
    data: {
      live: 'Données en direct · live.sogral.com',
      estimated: 'Estimation basée sur les tendances',
    },
    live: {
      searchBtn: 'Voir les départs',
      loading: 'Chargement...',
      refresh: 'Rafraîchir',
      errorMsg: 'Impossible de récupérer les départs. Réessayez.',
      noResults: 'Aucun départ trouvé pour cette destination et cette date.',
      departure: 'départ',
      departures: 'départs',
      pastDeparture: 'départ passé / annulé',
      pastDepartures: 'départs passés / annulés',
      transporterUnknown: 'Transporteur non communiqué',
      statusOpen: 'Ouvert',
      statusFull: 'Complet',
      statusCancelled: 'Annulé',
      statusDeparted: 'Parti',
      disclaimer: 'Données live SOGRAL, même contenu que Mahatati.',
      velocityAnalyzing: 'Analyse du rythme…',
      velocityStalled: "à l'arrêt",
      velocityCalm: 'tranquille',
      velocityMoving: 'ça bouge',
      velocityFast: 'ça part vite',
      velocityWindow: '+{n} places en {m} min',
    },
    home: {
      whereGoing: 'Où allez-vous ?',
      departureFrom: 'Départ : Alger – Gare routière Kharrouba',
      whichDay: 'Quel jour ?',
      chooseDest: 'Choisis ta destination pour voir les départs',
      liveSection: (n: number) => `Départs actuels (${n})`,
      pastSection: (n: number) => `Départs passés (${n})`,
    },
    predict: {
      tag: 'Prévision indicative',
      disclaimer: 'Basée sur les tendances observées les jours similaires (vendredi chargé, mardi calme…). Pas de données en temps réel sur cet onglet.',
    },
    footer: {
      tagline: 'Données SOGRAL en direct',
      privacy: 'Confidentialité',
      terms: 'Conditions',
      contact: 'Contact',
    },
    emptyHero: {
      title: 'Avant de partir à la gare routière',
      subtitle: 'Choisis ta destination, on te dit le meilleur créneau pour avoir une place sans faire la queue.',
      statLiveVal: 'Live',
      statLiveLabel: 'SOGRAL',
      statHistVal: '3 sem.',
      statHistLabel: "d'historique",
      statStationsVal: '2 gares',
      statStationsLabel: "d'Alger",
      popular: 'Trajets populaires depuis Alger',
      howTitle: 'Comment ça marche ?',
      step1: 'Choisis ta destination',
      step2: "Sélectionne aujourd'hui, demain ou une autre date",
      step3: "L'app combine les départs en temps réel avec l'historique des dernières semaines",
      step4: 'Tu vois le meilleur créneau pour partir tranquille',
    },
    onboarding: {
      skip: 'Passer',
      back: 'Retour',
      next: 'Suivant',
      start: "C'est parti !",
      screens: [
        { title: 'Choisis ton trajet', body: 'Sélectionne ta destination et la date. Toutes les wilayas desservies par SOGRAL depuis Alger.' },
        { title: 'Données en temps réel', body: "On combine les départs SOGRAL en direct avec l'historique des dernières semaines pour prédire l'affluence." },
        { title: 'Pars au bon moment', body: 'On te dit le créneau le moins chargé pour avoir une place sans faire la queue.\n\nإذا نروح ؟' },
      ],
    },
    cookie: {
      text: 'On utilise des cookies pour les statistiques et la publicité (AdSense). Tu peux refuser et garder uniquement les cookies essentiels.',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions',
      refuse: 'Refuser',
      accept: 'Accepter',
    },
    install: {
      title: 'Installer idaNroh',
      body: "Accès en 1 tap depuis ton écran d'accueil. Pas de Play Store.",
      install: 'Installer',
      later: 'Plus tard',
    },
    share: {
      btn: 'Partager le résultat',
      copied: 'Copié · à coller dans WhatsApp',
      shareTitle: 'idaNroh · Affluence des bus',
      header: (dest: string, day: string) => `🚌 idaNroh · ${dest} (${day})`,
      best: (time: string, pct: number) => `✅ Meilleur créneau : ${time} (${pct}% d'occupation)`,
      cta: "📊 Vois l'affluence en temps réel : https://idanroh.akoumad.design",
    },
    profile: {
      title: 'Profil',
      userAccounts: 'Comptes utilisateur',
      comingSoon: 'Bientôt disponible',
      version: 'Version',
      source: 'Source',
      mode: 'Mode',
      demo: 'Démo (données simulées)',
      production: 'Production',
      language: 'Langue',
      langFr: 'Français',
      langAr: 'العربية',
    },
  },

  ar: {
    nav: {
      predict: 'خطّط',
      live: 'الآن',
      dashboard: 'المحطة',
      transporters: 'الناقلون',
      history: 'السجل',
      trends: 'الاتجاهات',
      profile: 'الملف',
    },
    navDesc: {
      predict: 'متى أسافر؟',
      live: 'هل المحطة مزدحمة الآن؟',
      dashboard: 'أرقام المحطة الحقيقية',
      transporters: 'دليل المشغلين',
      history: 'عمليات البحث الأخيرة',
      trends: 'الأنماط الأسبوعية',
      profile: 'الإعدادات',
    },
    sidebar: {
      collapse: 'طيّ',
      themeLight: 'فاتح',
      themeDark: 'داكن',
      themeSystem: 'تلقائي',
    },
    search: {
      from: 'محطة الانطلاق',
      fromValue: 'الجزائر (الخروبة)',
      to: 'الوجهة',
      chooseDest: 'اختر الوجهة',
      loadingDest: 'جارٍ تحميل الوجهات...',
      today: 'اليوم',
      tomorrow: 'غداً',
      choose: 'اختر تاريخاً',
      dayNames: ['أحد', 'إثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت'],
      dayFull: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
      searchBtn: 'عرض التوقّع',
      loading: 'جارٍ الحساب...',
      errorMsg: 'تعذّر الحساب. حاول مرة أخرى.',
    },
    liveToggle: {
      mine: 'وجهتي',
      all: 'كل المحطة',
    },
    via: 'عبر',
    board: {
      station: (id: number) => (id === 1 ? 'الجزائر · الكاروبية' : id === 2 ? 'الجزائر · الخروبة' : 'الجزائر (الخروبة)'),
      title: (station: string) => `محطة ${station} · كل الرحلات`,
      empty: 'لا توجد رحلات اليوم في هذه المحطة.',
      pastGone: (n: number) => `${n} انطلقت بالفعل`,
      upcoming: (n: number) => `${n} رحلة قادمة`,
      open: 'متاح',
      gone: 'انطلقت',
      assured: 'مؤكَّدة',
      full: 'مكتملة',
      seats: 'مقعد',
      min: 'دق',
    },
    sync: {
      live: 'مباشر',
      now: 'الآن',
      agoSec: (s: number) => `قبل ${s} ث`,
      agoMin: (m: number) => `قبل ${m} دق`,
      auto: (s: number) => `كل ${s} ث`,
      title: (s: number) => `تحديث تلقائي كل ${s} ثانية`,
    },
    slotVerdict: {
      complete: 'مكتملة',
      high: 'ممتلئة',
      medium: 'تمتلئ',
      low: 'مريحة',
    },
    slots: {
      header: (day: string, n: number) => `${day} · ${n} رحلة`,
      legendLow: 'مريحة',
      legendMedium: 'تمتلئ',
      legendHigh: 'ممتلئة',
      srcLive: 'المقاعد المتبقية مباشرة',
      srcHist: (n: number, day: string) => `متوسط ${n} «${day}» سابقة`,
      srcHistEst: ' (تقدير)',
      srcSynthetic: 'تقدير (بيانات قليلة)',
    },
    verdict: {
      noData: 'بيانات غير كافية',
      noDataSub: 'حاول لاحقاً أو اختر يوماً آخر.',
      noMore: 'لا رحلات أخرى اليوم',
      noMoreSub: 'جرّب تاريخاً آخر.',
      goToday: (time: string) => `الفترة الأقل ازدحاماً المقدَّرة: ${time}`,
      goFuture: (day: string, time: string) => `${day}، الفترة الأقل ازدحاماً المقدَّرة: ${time}`,
      goSub: (pct: number, isToday: boolean) =>
        `نحو ${pct}% امتلاء مقدَّر${isToday ? ' حتى نهاية اليوم' : ''}.`,
      waitHead: (time: string) => `الفترة الأهدأ المقدَّرة: ${time}`,
      waitSub: (pct: number, isToday: boolean) =>
        `نحو ${pct}% امتلاء مقدَّر${isToday ? ' حتى نهاية اليوم' : ''}. احضر مبكراً قليلاً.`,
      avoidHead: (isToday: boolean) => `إقبال مرتفع مقدَّر${isToday ? ' حتى نهاية اليوم' : ''}`,
      avoidSub: (time: string, pct: number) =>
        `الأقل ازدحاماً المقدَّر: ${time} (نحو ${pct}%). يُفضَّل يوم آخر إن أمكن.`,
    },
    badge: {
      low: 'منخفض',
      medium: 'متوسط',
      high: 'مرتفع',
    },
    altDays: {
      title: 'أيام بديلة أقل ازدحاماً',
    },
    data: {
      live: 'بيانات مباشرة · live.sogral.com',
      estimated: 'تقدير بناءً على الاتجاهات',
    },
    live: {
      searchBtn: 'عرض الرحلات',
      loading: 'جارٍ التحميل...',
      refresh: 'تحديث',
      errorMsg: 'تعذّر جلب الرحلات. حاول مرة أخرى.',
      noResults: 'لا توجد رحلات لهذه الوجهة في هذا التاريخ.',
      departure: 'رحلة',
      departures: 'رحلات',
      pastDeparture: 'رحلة سابقة / ملغاة',
      pastDepartures: 'رحلات سابقة / ملغاة',
      transporterUnknown: 'الناقل غير محدّد',
      statusOpen: 'متاحة',
      statusFull: 'مكتملة',
      statusCancelled: 'ملغاة',
      statusDeparted: 'انطلقت',
      disclaimer: 'بيانات SOGRAL المباشرة، نفس ما تراه في تطبيق محطّتي.',
      velocityAnalyzing: 'جارٍ قياس الوتيرة…',
      velocityStalled: 'متوقّفة',
      velocityCalm: 'هادئة',
      velocityMoving: 'تتحرّك',
      velocityFast: 'تنفد بسرعة',
      velocityWindow: '+{n} مقعد خلال {m} دق',
    },
    home: {
      whereGoing: 'إلى أين تذهب؟',
      departureFrom: 'الانطلاق : الجزائر – محطة الخروبة',
      whichDay: 'أي يوم؟',
      chooseDest: 'اختر وجهتك لعرض الرحلات',
      liveSection: (n: number) => `الرحلات الحالية (${n})`,
      pastSection: (n: number) => `الرحلات المنتهية (${n})`,
    },
    predict: {
      tag: 'توقّع استرشادي',
      disclaimer: 'مبني على الأنماط السابقة لأيام مماثلة (الجمعة مزدحمة، الثلاثاء هادئ…). لا توجد بيانات لحظية في هذا القسم.',
    },
    footer: {
      tagline: 'بيانات SOGRAL مباشرة',
      privacy: 'الخصوصية',
      terms: 'الشروط',
      contact: 'اتصل بنا',
    },
    emptyHero: {
      title: 'قبل التوجّه إلى المحطة',
      subtitle: 'اختر وجهتك، ونخبرك بأفضل وقت للحصول على مقعد دون طابور.',
      statLiveVal: 'مباشر',
      statLiveLabel: 'SOGRAL',
      statHistVal: '٣ أسابيع',
      statHistLabel: 'من السجلّ',
      statStationsVal: 'محطّتان',
      statStationsLabel: 'بالجزائر',
      popular: 'وجهات شائعة من الجزائر',
      howTitle: 'كيف يعمل؟',
      step1: 'اختر وجهتك',
      step2: 'اختر اليوم أو غداً أو تاريخاً آخر',
      step3: 'يجمع التطبيق بين الرحلات المباشرة وسجلّ الأسابيع الأخيرة',
      step4: 'ترى أفضل وقت للسفر براحة',
    },
    onboarding: {
      skip: 'تخطّي',
      back: 'رجوع',
      next: 'التالي',
      start: 'لنبدأ !',
      screens: [
        { title: 'اختر رحلتك', body: 'اختر وجهتك والتاريخ. كل الولايات التي تخدمها SOGRAL انطلاقاً من الجزائر.' },
        { title: 'بيانات لحظية', body: 'نجمع بين رحلات SOGRAL المباشرة وسجلّ الأسابيع الأخيرة للتنبّؤ بالازدحام.' },
        { title: 'سافر في الوقت المناسب', body: 'نخبرك بالوقت الأقل ازدحاماً للحصول على مقعد دون طابور.\n\nإذا نروح ؟' },
      ],
    },
    cookie: {
      text: 'نستخدم ملفات تعريف الارتباط للإحصاءات والإعلانات (AdSense). يمكنك الرفض والاكتفاء بالملفات الأساسية.',
      privacy: 'سياسة الخصوصية',
      terms: 'الشروط',
      refuse: 'رفض',
      accept: 'قبول',
    },
    install: {
      title: 'ثبّت idaNroh',
      body: 'وصول بنقرة واحدة من شاشتك الرئيسية. دون متجر Play.',
      install: 'تثبيت',
      later: 'لاحقاً',
    },
    share: {
      btn: 'شارك النتيجة',
      copied: 'تم النسخ · الصقه في واتساب',
      shareTitle: 'idaNroh · ازدحام الحافلات',
      header: (dest: string, day: string) => `🚌 idaNroh · ${dest} (${day})`,
      best: (time: string, pct: number) => `✅ أفضل وقت: ${time} (${pct}% امتلاء)`,
      cta: '📊 شاهد الازدحام مباشرة: https://idanroh.akoumad.design',
    },
    profile: {
      title: 'الملف الشخصي',
      userAccounts: 'حساب المستخدم',
      comingSoon: 'قريباً',
      version: 'الإصدار',
      source: 'المصدر',
      mode: 'الوضع',
      demo: 'عرض توضيحي (بيانات محاكاة)',
      production: 'إنتاج',
      language: 'اللغة',
      langFr: 'Français',
      langAr: 'العربية',
    },
  },
} as const;
